import { Button } from "@/components/ui/button"
import { ArrowLeft, Edit } from "lucide-react"
import { Product } from "@/types/product-type"
import { useLocation } from "wouter"

interface ProductDetailHeaderProps {
  product: Product
  onEdit: () => void
}

export function ProductDetailHeader({ product, onEdit }: ProductDetailHeaderProps) {
  const [, setLocation] = useLocation()

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <Button variant="ghost" size="sm" onClick={() => setLocation("/products")}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Products
        </Button>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{product.name}</h1>
          <p className="text-muted-foreground">Code: {product.code}</p>
        </div>
      </div>
      <Button onClick={onEdit}>
        <Edit className="mr-2 h-4 w-4" />
        Edit Product
      </Button>
    </div>
  )
}
